<div class="store-item">
  <div class="store-state">
    <div [ngClass]="{
								'store-status online-store': store.IsActive,
								'store-status offline-store': !store.IsActive
							  }">
    </div>
    {{ store.IsActive ? 'Online' : 'Offline'}}
  </div>
  <div class="store-bx bg-class">
    <img *ngIf="store.IsShopifyStore"style="height:160  px;width:200px;float:right" src="assets/img/shopify-icon.png"
         alt="store image">
    <img *ngIf="!store.IsShopifyStore" [src]="store.StoreSetting == null || store.StoreSetting.StoreImageBanner == null ? 'http://placehold.it/400' : store.StoreSetting.StoreImageBanner"
         alt="store image">
    <mat-label class="store-name">{{store.StoreName}}</mat-label>
  </div>


  <div *ngIf="!store.IsShopifyStore" class="store-footer">
    <a class="btn btn-sm btn-info" [routerLink]="[ '/store/edit', store.StoreId ]">Edit</a>
    <a class="btn btn-sm btn-success"
       target="_blank"
       [routerLink]="[ '/store/store-editor', store.StoreId ]">Customize Storefront</a>
    <a *ngIf="store.IsActive" target="_blank" class="btn btn-sm btn-warning" [routerLink]="[ '/', store.StoreUrl ]">Preview</a>

    <a target="_blank" class="btn btn-sm btn-danger" (click)="openDialog(store.StoreId,store.StoreName)">Delete</a>
  </div>
</div>
